<template>
  <div class="s-diseases-container container">
    <topNav></topNav>
    <div class="s-diseases-top">
      <div class="banner w1300 marginAuto"></div>
      <div class="w1300 marginAuto">

        <div class="query">
          <el-input v-model="queryKey" placeholder="请输入关键词搜索" class="search_input">
            <template v-slot:suffix>
              <i class="el-input__icon el-icon-search" @click="handleSearch" @keyup.enter="handleSearch"></i>
            </template>
          </el-input>
          <div class="issue" @click="handleSearch">搜索</div>
        </div>


        <!--        <div class="query">-->
        <!--          <el-input class="search_input" v-model="queryKey" placeholder="请输入关键字查询"></el-input>-->
        <!--          <div class="issue" @click="handleSearch">搜索</div>-->
        <!--        </div>-->
      </div>
      <div class="s-professionalInfos-onsultation-tabs w1300 marginAuto">
        <div @click="handleTabs('农技技术')" :class="[
          currentTab == '农技技术'
            ? 's-professionalInfos-onsultation-tabs-active'
            : '',
        ]">农技技术</div>
        <div @click="handleTabs('视频技术')" :class="[
          currentTab == '视频技术'
            ? 's-professionalInfos-onsultation-tabs-active'
            : '',
        ]">视频技术</div>
        <div @click="handleTabs('病虫害防治')" :class="[
          currentTab == '病虫害防治'
            ? 's-professionalInfos-onsultation-tabs-active'
            : '',
        ]">病虫害防治</div>
        <div @click="handleTabs('作物施肥技术')" :class="[
          currentTab == '作物施肥技术'
            ? 's-professionalInfos-onsultation-tabs-active'
            : '',
        ]">作物施肥技术</div>
      </div>
    </div>

    <div class="section w1300 marginAuto sectionList">
      <div class="information-item" v-if="dataList.length > 0 && currentTab != '视频技术'" v-for="(item, index) in dataList"
        :key="index" @click="getInfodetail(item)">
        <div class="info-date">
          <div class="info-day">{{ item.uploadDate.split('-')[2].slice(0, 2) }}</div>
          <div class="info-year">{{ item.uploadDate.split('-')[0] }}.{{ item.uploadDate.split('-')[1] }}</div>
        </div>
        <div class="information-item-content">
          <div class="information-item-title">{{ item.informationTitle }}</div>
          <div class="information-item-text">{{ item.briefIntroduction }}</div>
          <div class="information-item-source" v-if="item.dataSources">【来源：{{ item.dataSources }}】</div>
        </div>
      </div>
      <div class="video-container" v-if="dataList.length > 0 && currentTab == '视频技术'">
        <div class="video-block" v-for="(item, index) in dataList" :key="index">
          <div class="video-player">
            <video ref="video" class="video-player-dom video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls
              :poster="item.icon ? (imgURL + item.icon) : ''" preload muted>
              <source :src="imgURL + item.videoUrl" />
            </video>
          </div>
          <div class="video-block-title">{{ item.informationTitle }}</div>
        </div>
      </div>
    </div>

    <div class="emptyDiv" v-show="dataList.length == 0">
      <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>

    <div class="s-transaction-pagination">
      <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next"
        @current-change="currentChange" :total="total"></el-pagination>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { getInformationListPage } from '../utils/api/agriculture'
export default {
  name: "",
  components: { topNav, footerNav },
  data() {
    return {
      queryKey: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentTab: "农技技术",
      dataList: [],
      noDataImg: require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    this.getInformationListPage()
  },
  methods: {
    handleTabs(text) {
      this.currentPage = 1;
      this.currentTab = text;
      this.dataList = []
      this.getInformationListPage()
    },
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.getInformationListPage();
    },
    // 分页
    currentChange(val) {
      this.currentPage = val;
      // this.pageList();
      this.getInformationListPage();
    },
    async getInformationListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        title: this.queryKey,
        type: this.currentTab
      }
      let res = await getInformationListPage(params)
      if ([200, 0].includes(res.data.code)) {
        this.dataList = res.data.data.records
        this.total = res.data.data.total;
      }
    },
    getInfodetail(item) {
      console.log(item, "item");
      var url = `${location.origin + location.pathname}#agricultureDetails?id=${item.id}`;
      window.open(url)
      // this.$router.push({
      //     path: "/info-details",
      //     query: {
      //         id: this.data.id,
      //         path: this.$route.path
      //     }
      // })
    }
  }
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/diseasesInsectPests.scss";
</style>
